let pipelineWorkerUrl;
export function setPipelineWorkerUrl(workerUrl) {
    pipelineWorkerUrl = workerUrl;
}
export function getPipelineWorkerUrl() {
    return pipelineWorkerUrl;
}
//# sourceMappingURL=pipeline-worker-url.js.map